import PropTypes from "prop-types"
import { connect } from "react-redux"

import { trackSlide } from "areas/product/store/actions"

/**
 * Product main image slider
 * @property {array} availableViews - product available view keys
 * @property {bool} blur - blurs image when wizard is loading
 * @property {object} slides - product images + videos data object
 * @property {array} videos - product videos
 */
export default function withImages(WrappedComponent) {
  const InternalImages = (props) => {
    if (!props.availableViews) {
      return null
    }

    return <WrappedComponent {...props} />
  }

  InternalImages.propTypes = {
    availableViews: PropTypes.array,
    currentSlideIndex: PropTypes.number,
    slidesArray: PropTypes.array,
    styleCode: PropTypes.string,
    wizardLoading: PropTypes.string,
  }

  const mapStateToProps = (state) => {
    let availableViews = []
    let slidesArray = []

    if (state.previewImage.data) {
      const slides = state.previewImage.data.images
      availableViews = state.previewImage.data.all_views.filter((view) => {
        return slides[view] || slides[`${view}_view`]
      })
      slidesArray = availableViews.map((view) => {
        let slide = slides[`${view}_view`] || slides[view]
        slide.view = view
        // get face2 for flip rings
        if (
          state.previewImageUI.flipped &&
          typeof slides[`face2_${view}_view`] !== "undefined"
        ) {
          slide = slides[`face2_${view}_view`]
          slide.view = `face_2_${view}`
        }
        return slide
      })
    }

    const j3dSlideIndex = slidesArray.findIndex((slide) => slide.view === "j3d")

    const title = state.wizard.title
    const altText = state.wizard.alt_text
    const productTitle = altText ? `${title} – ${altText}` : title

    return {
      availableViews,
      currentSlideIndex: state.previewImage.slideIndex,
      j3dSlideIndex,
      productTitle,
      productType: state.wizard.description.product_type,
      showJ3d: state.previewImage.j3d,
      showJ3dV2: state.previewImage.j3dV2,
      slidesArray,
      styleCode: state.wizard.description.style_code,
      wizardLoading: state.wizard.loading,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      trackSlide: (index) => {
        dispatch(trackSlide(index))
      },
    }
  }

  const Images = connect(mapStateToProps, mapDispatchToProps)(InternalImages)

  return Images
}
